// {
//     id: 43896,
//         login: "ag755406",
//     hasDiffusion: true,
//     hasContactManager: false,
//     hasLocalSeo: false,
//     updatedAt: "2021-08-05T04:27:09+02:00",
//     createdAt: "2021-08-05T04:27:09+02:00"
// }

export default {
  namespaced: true,
  state: {
    products: {}
  },
  getters: {
    getProducts: (state) => {
      return state.products
    },
    hasDiffusion: (state) => {
      return state.products && state.products.hasDiffusion
    },
  	hasLocalSeo: (state) => {
      return state.products && state.products.hasLocalSeo
    },
    hasContactManager: (state) => {
      return state.products && state.products.hasContactManager
    }
  },
  mutations: {
    setProducts (state, products) {
      state.products = products
    }
  },
  actions: {
    setProducts ({ commit }, products) {
      commit('setProducts', products)
    }
  }
}
